var map = {
	"./day/kh.jpg": 3251,
	"./day/leap.jpg": 9052,
	"./day/mt.jpg": 4861,
	"./day/sc.jpg": 1636,
	"./day/tn.jpg": 2636,
	"./day/vnone.jpg": 2668,
	"./ng/mt.jpg": 7272,
	"./ng/tn.jpg": 3621,
	"./ng/vnone.jpg": 3471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7948;